/**
 * Motorista
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource, ToastConfig, ID} from 'simpli-web-sdk'
import {ResponseExclude, ResponseSerialize} from 'simpli-web-sdk'
import {Endereco} from '@/model/resource/Endereco'
import {MotoristaCollection} from '@/model/collection/MotoristaCollection'
import {Responsavel} from '@/model/resource/Responsavel'
import {MotoristaJornada} from '@/model/resource/MotoristaJornada'
import {TipoVeiculoCollection} from '@/model/collection/TipoVeiculoCollection'
import {TipoCarroceriaCollection} from '@/model/collection/TipoCarroceriaCollection'
import {TipoMarcaVeiculoCollection} from '@/model/collection/TipoMarcaVeiculoCollection'
import {MotoristaAlteracaoInfo} from '@/model/resource/MotoristaAlteracaoInfo'

/* TODO: review generated class */
export class Motorista extends Resource {
  idMotoristaPk: number = 0

  @ResponseSerialize(Endereco)
  endereco: Endereco | null = null

  @ResponseSerialize(MotoristaJornada)
  jornadaMotorista: MotoristaJornada | null = null

  @ResponseSerialize(MotoristaAlteracaoInfo)
  motoristaAlteracaoInfo: MotoristaAlteracaoInfo | null = null

  /**
   * Pode ser null porque o responsavel poderá cadastrar, so o motorista informa este campo.
   */
  placaVeiculo: string | null = null

  /**
   * Utilizar para cadastro e esqueci senha
   */
  codigoSms: string | null = null

  /**
   * Pode ser null porque o responsavel pode cadastrar sem foto e o motorista pode não
   * informar
   */
  urlImagem: string | null = null

  nome: string | null = null
  cpf: string | null = null
  rg: string | null = null
  celular: string | null = null
  tipoVeiculo: string | null = null
  dataNascimento: string | null = null
  dataCriacao: string | null = null
  ativo: boolean | null = null

  email: string | null = null
  telefoneFixo: string | null = null
  tipoCarreta: string | null = null
  tipoCarroceria: string | null = null
  placaCarroceira: string | null = null
  antt: string | null = null
  rntrc: string | null = null
  cnh: string | null = null
  marcaVeiculo: string | null = null
  idResponsavelCriadorFk: number | null = null
  nomeIndicador: string | null = null
  tokenAndroid: string | null = null
  versao: string | null = null
  marcaAparelho: string | null = null
  modeloAparelho: string | null = null
  responsavelCriador: Responsavel | null = null
  idMotoristaJornadaFk: number = 0

  /**
   * Senha não é obrigatorio porque o responsavel pode cadastrar. O Motorista que deverá informar ao
   * receber codigo do SMS
   */
  @ResponseExclude()
  senha: string | null = null

  get $id() {
    return this.idMotoristaPk
  }
  set $id(val) {
    this.idMotoristaPk = val
  }
  get $tag() {
    return String(this.nome)
  }

  get idEnderecoFk() {
    if (!this.endereco) return 0
    return this.endereco.$id
  }
  set idEnderecoFk(val) {
    if (!this.endereco) this.endereco = new Endereco()
    this.endereco.$id = val
  }

  get nomeCriador() {
    return (
      this.responsavelCriador?.razaoSocial ||
      this.responsavelCriador?.nomeFantasia ||
      this.responsavelCriador?.nomeContato ||
      'Admin'
    )
  }

  set tipoVeiculoAsResource(input: Resource | null) {
    this.tipoVeiculo = input?.$tag || null
  }

  get tipoVeiculoAsResource() {
    return new TipoVeiculoCollection().options().getResource(this.tipoVeiculo)
  }

  set tipoCarroceriaAsResource(input: Resource | null) {
    this.tipoCarroceria = input?.$tag || null
  }

  get tipoCarroceriaAsResource() {
    return new TipoCarroceriaCollection()
      .options()
      .getResource(this.tipoCarroceria)
  }

  set marcaVeiculoAsResource(input: Resource | null) {
    this.marcaVeiculo = input?.$tag || null
  }

  get marcaVeiculoAsResource() {
    return new TipoMarcaVeiculoCollection()
      .options()
      .getResource(this.marcaVeiculo)
  }

  /**
   * Check If CPF exits
   */
  async checkCpfExist() {
    return await Request.get(
      `/admin/motorista/existCpf/${this.cpf}/${this.idMotoristaPk}`
    )
      .name('existCpf')
      .asBoolean()
      .getData()
  }

  /**
   * Gets a instance of a given ID of Motorista
   */
  async getMotorista(id: number) {
    return await Request.get(`/admin/motorista/${id}`)
      .name('getMotorista')
      .as(this)
      .getData()
  }

  /**
   * Deletes a instance of a given ID of Motorista
   */
  async removeMotorista() {
    return await Request.delete(`/admin/motorista/${this.$id}`)
      .name('removeMotorista')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of Motorista
   */
  static async listMotorista(params: any) {
    return await Request.get(`/admin/motorista`, {params})
      .name('listMotorista')
      .as(MotoristaCollection)
      .getData()
  }

  /**
   * Persists a new instance of Motorista. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistMotorista() {
    return await Request.post(`/admin/motorista`, this)
      .name('persistMotorista')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of Motorista to use it in a CSV file
   */
  static async listCsvMotorista(params: any) {
    return await Request.get(`/admin/motorista/csv`, {params})
      .name('listCsvMotorista')
      .as(MotoristaCollection)
      .getData()
  }

  static async notifyMotoristas(text: string, motoristas: ID[], all: boolean) {
    return await Request.post(`/admin/motorista/notificacao`, {
      text,
      motoristas,
      all,
    })
      .name('notifyMotoristas')
      .asBoolean()
      .getData()
  }
}
